function animateCounter(el) {
  if (el.dataset.done === '1') return;
  el.dataset.done = '1';
  const target   = Number(el.dataset.count || 0);
  const suffix   = el.dataset.suffix || '';
  const duration = 1600;
  let start = null;

  function frame(time) {
    if (!start) start = time;
    const progress = Math.min((time - start) / duration, 1);
    const eased    = 1 - Math.pow(1 - progress, 3);
    el.textContent = Math.round(target * eased) + suffix;
    if (progress < 1) requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
}

export function initCountup() {
  const counters = document.querySelectorAll('[data-count]');
  if (!counters.length) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.35 });
    counters.forEach((el) => observer.observe(el));
  } else {
    counters.forEach(animateCounter);
  }
}
